import GetRegions from '@/services/canvassers/regionService/GetRegions';

export default class RegionService {
    /**
     * Get canvasser regions.
     *
     * @returns {Array}
     */
    getRegions() {
        return (new GetRegions()).handle();
    }
}
